// extracted by mini-css-extract-plugin
export default {"datePicker":"dispatch-information-form_datePicker__XUo1A"};